/* eslint-disable react/prop-types */
import React from 'react';
import {
    Box,
    Grid,
    TextField,
    Checkbox,
    FormControlLabel,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    OutlinedInput,
    Typography,
    ListItemText,
    FormHelperText,
    FormLabel,
    Collapse,
    IconButton,
    Radio,
    RadioGroup,
    Autocomplete,
    Chip
} from '@mui/material';
import { Field, ErrorMessage } from 'formik';
import SubCard from 'ui-component/cards/SubCard';
import { tips } from './HelpData';
import HelpIcon from './HelpIcon';
import { roles } from 'store/constant';
import Remarks from './Remarks';
import { ExpandLess, ExpandMore } from '@mui/icons-material';

const ShowingInformation = ({ role, values, handleSubmit, handleChange, handleBlur, isSubmitting, setFieldValue, touched, errors }) => {
    const [openOptional, setOpenOptional] = React.useState(true);

    const handleToggle = () => {
        setOpenOptional((prev) => !prev);
    };
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Typography
                    sx={{
                        color: '#919191',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        fontWeight: '700',
                        lineHeight: 'normal',
                        textTransform: 'capitalize',
                        mb: 2
                    }}
                >
                    Showing Information
                </Typography>
                <SubCard sx={{ mt: '20px' }}>
                    <Grid container spacing={2}>
                        {role === roles.ADMIN && (
                            <Grid item xs={12} sm={7}>
                                <Box sx={{ display: 'flex' }}>
                                    <FormControl fullWidth required error={touched.occupantType && Boolean(errors.occupantType)}>
                                        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                    Occupant Type
                                                </Typography>
                                            </FormLabel>
                                            <HelpIcon
                                                title={tips?.occupantType.title}
                                                ruleHelp={tips?.occupantType.ruleHelp}
                                                generalHelpDesc={tips?.occupantType.generalHelpDesc}
                                            />
                                        </Box>
                                        <RadioGroup
                                            aria-label="listing-agreement"
                                            name="occupantType"
                                            value={values.occupantType}
                                            onChange={handleChange}
                                            row
                                            sx={{ gap: 1, ml: 1, mt: 1 }}
                                        >
                                            <FormControlLabel
                                                value="Owner"
                                                control={<Radio />}
                                                label="Owner"
                                                sx={{
                                                    border: '1px solid #ccc',
                                                    borderRadius: '5px',
                                                    padding: '2px 14px',
                                                    minWidth: '180px'
                                                }}
                                            />

                                            <FormControlLabel
                                                value="Tenant"
                                                control={<Radio />}
                                                label="Tenant"
                                                sx={{
                                                    border: '1px solid #ccc',
                                                    borderRadius: '5px',
                                                    padding: '2px 14px',
                                                    minWidth: '180px',
                                                    justifyContent: 'center'
                                                }}
                                            />

                                            <FormControlLabel
                                                value="Vacant"
                                                control={<Radio />}
                                                label="Vacant"
                                                sx={{
                                                    border: '1px solid #ccc',
                                                    borderRadius: '5px',
                                                    padding: '2px 14px',
                                                    minWidth: '180px',
                                                    justifyContent: 'center'
                                                }}
                                            />
                                        </RadioGroup>
                                        {/* <Select
                                            value={values.occupantType}
                                            onChange={(event) => {
                                                setFieldValue('occupantType', event.target.value);
                                            }}
                                            onBlur={handleBlur}
                                            input={<OutlinedInput />}
                                        >
                                            {['Owner', 'Tenant', 'Vacant'].map((option) => (
                                                <MenuItem key={option} value={option} sx={{ my: 0.5 }}>
                                                    <ListItemText primary={option} />
                                                </MenuItem>
                                            ))}
                                        </Select> */}
                                        {touched.occupantType && errors.occupantType && (
                                            <FormHelperText>{errors.occupantType}</FormHelperText>
                                        )}
                                    </FormControl>
                                </Box>
                            </Grid>
                        )}
                        <Grid item xs={12} sm={3}>
                            <Box sx={{ display: 'flex' }}>
                                <FormControl fullWidth required error={touched.ownerName && Boolean(errors.ownerName)}>
                                    <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                        <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                            <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                Owner Name
                                            </Typography>
                                        </FormLabel>
                                        <HelpIcon
                                            title={tips?.ownerName.title}
                                            ruleHelp={tips?.ownerName.ruleHelp}
                                            generalHelpDesc={tips?.ownerName.generalHelpDesc}
                                        />
                                    </Box>
                                    <Field
                                        as={TextField}
                                        fullWidth
                                        required
                                        name="ownerName"
                                        variant="outlined"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.ownerName}
                                        error={touched.ownerName && Boolean(errors.ownerName)}
                                        helperText={<ErrorMessage name="ownerName" />}
                                    />
                                </FormControl>
                            </Box>
                        </Grid>
                    </Grid>
                </SubCard>
                {role === roles.ADMIN && (
                    <Grid item xs={12}>
                        <Typography
                            sx={{
                                color: '#919191',
                                fontSize: '16px',
                                fontStyle: 'normal',
                                fontWeight: '700',
                                lineHeight: 'normal',
                                textTransform: 'capitalize',
                                my: 2
                            }}
                        >
                            Lockbox Information
                        </Typography>
                        <SubCard>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4}>
                                    <Box sx={{ display: 'flex' }}>
                                        <FormControl
                                            fullWidth
                                            required
                                            error={touched.lockboxType && Boolean(errors.lockboxType)}
                                            variant="outlined"
                                        >
                                            <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                    <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                        Lockbox Type
                                                    </Typography>
                                                </FormLabel>
                                                <HelpIcon
                                                    title={tips?.lockboxType.title}
                                                    ruleHelp={tips?.lockboxType.ruleHelp}
                                                    generalHelpDesc={tips?.lockboxType.generalHelpDesc}
                                                />
                                            </Box>
                                            <Autocomplete
                                                renderTags={(tagValue, getTagProps) =>
                                                    tagValue.map((option, index) => (
                                                        <Chip
                                                            key={index}
                                                            label={option}
                                                            {...getTagProps({ index })}
                                                            sx={{
                                                                '& .MuiChip-deleteIcon': {
                                                                    color: 'black !important'
                                                                }
                                                            }}
                                                        />
                                                    ))
                                                }
                                                options={['Both', 'Combo', 'SUPRA', 'None', 'See Remarks']} // Options for Lockbox Types
                                                value={values.lockboxType || null} // Set current value
                                                onChange={(event, newValue) => {
                                                    setFieldValue('lockboxType', newValue);
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        variant="outlined"
                                                        error={touched.lockboxType && Boolean(errors.lockboxType)}
                                                    />
                                                )}
                                                isOptionEqualToValue={(option, value) => option === value} // Compare options as strings
                                            />
                                            {touched.lockboxType && errors.lockboxType && (
                                                <FormHelperText>{errors.lockboxType}</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Box>
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <Box sx={{ display: 'flex' }}>
                                        <FormControl fullWidth error={touched.lockboxLocation && Boolean(errors.lockboxLocation)}>
                                            <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                    <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                        Lockbox Location
                                                    </Typography>
                                                </FormLabel>
                                                <HelpIcon
                                                    title={tips?.lockboxLocation.title}
                                                    ruleHelp={tips?.lockboxLocation.ruleHelp}
                                                    generalHelpDesc={tips?.lockboxLocation.generalHelpDesc}
                                                />
                                            </Box>
                                            <Field
                                                as={TextField}
                                                fullWidth
                                                name="lockboxLocation"
                                                variant="outlined"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.lockboxLocation}
                                                error={touched.lockboxLocation && Boolean(errors.lockboxLocation)}
                                                helperText={<ErrorMessage name="lockboxLocation" />}
                                            />
                                            {touched.lockboxLocation && errors.lockboxLocation && (
                                                <FormHelperText>{errors.lockboxLocation}</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Box>
                                </Grid>
                            </Grid>
                        </SubCard>
                    </Grid>
                )}
                {/* <Grid item xs={12}>
                    <Typography
                        sx={{
                            color: '#919191',
                            fontSize: '16px',
                            fontStyle: 'normal',
                            fontWeight: '700',
                            lineHeight: 'normal',
                            textTransform: 'capitalize',
                            my: 2
                        }}
                    >
                        Company Management Information
                    </Typography>
                    <SubCard>
                        <Grid container spacing={2} />
                    </SubCard>
                </Grid> */}

                <Grid item xs={12}>
                    <Typography
                        sx={{
                            color: '#919191',
                            fontSize: '16px',
                            fontStyle: 'normal',
                            fontWeight: '700',
                            lineHeight: 'normal',
                            textTransform: 'capitalize',
                            my: 2
                        }}
                    >
                        About Information
                    </Typography>
                    <SubCard>
                        <Grid container spacing={2}>
                            {role === roles.ADMIN && (
                                <Grid item xs={12} sm={4}>
                                    <Box sx={{ display: 'flex' }}>
                                        <FormControl
                                            fullWidth
                                            required
                                            error={touched.showingRequirements && Boolean(errors.showingRequirements)}
                                        >
                                            <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                    <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                        Showing Requirements
                                                    </Typography>
                                                </FormLabel>
                                                <HelpIcon
                                                    title={tips?.showingRequirements.title}
                                                    ruleHelp={tips?.showingRequirements.ruleHelp}
                                                    generalHelpDesc={tips?.showingRequirements.generalHelpDesc}
                                                    generalHelp={tips?.showingRequirements.generalHelp}
                                                />
                                            </Box>
                                            <Autocomplete
                                                renderTags={(tagValue, getTagProps) =>
                                                    tagValue.map((option, index) => (
                                                        <Chip
                                                            key={index}
                                                            label={option}
                                                            {...getTagProps({ index })}
                                                            sx={{
                                                                '& .MuiChip-deleteIcon': {
                                                                    color: 'black !important'
                                                                }
                                                            }}
                                                        />
                                                    ))
                                                }
                                                multiple
                                                options={[
                                                    '24 Hour Notice',
                                                    'Agent or Owner Present',
                                                    'Appointment Only',
                                                    'Call First - Go',
                                                    'Call Listing Agent',
                                                    'Call Listing Office',
                                                    'Call Manager',
                                                    'Call Owner',
                                                    'Call Tenant',
                                                    'Day Sleeper',
                                                    'Do Not Disturb Tenant, Mgt, etc.',
                                                    'Email Listing Agent',
                                                    'Go',
                                                    'Key in Office',
                                                    'Key with Gate Guard',
                                                    'Key with Listing Agent',
                                                    'Key with Listing Office',
                                                    'Key with Management Company',
                                                    'Key with Occupant',
                                                    'Key with Owner',
                                                    'Lockbox',
                                                    'Pet(s) on Premises',
                                                    'Restricted Hours',
                                                    'Security System',
                                                    'See Showing Instructions',
                                                    'Showing Service',
                                                    'Sign on Property',
                                                    'Text Listing Agent'
                                                ]}
                                                value={values.showingRequirements || []} // Handle value as an array
                                                onChange={(event, newValue) => {
                                                    setFieldValue('showingRequirements', newValue);
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        variant="outlined"
                                                        error={touched.showingRequirements && Boolean(errors.showingRequirements)}
                                                    />
                                                )}
                                                disableCloseOnSelect
                                                renderOption={(props, option, { selected }) => (
                                                    <li {...props}>
                                                        <Checkbox checked={selected} />
                                                        <ListItemText primary={option} />
                                                    </li>
                                                )}
                                                isOptionEqualToValue={(option, value) => option === value} // Compare options as strings
                                            />
                                            {touched.showingRequirements && errors.showingRequirements && (
                                                <FormHelperText>{errors.showingRequirements}</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Box>
                                </Grid>
                            )}

                            <Grid item xs={12} sm={4}>
                                <Box sx={{ display: 'flex' }}>
                                    <FormControl
                                        fullWidth
                                        required
                                        error={touched.showingContactPhone && Boolean(errors.showingContactPhone)}
                                    >
                                        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                    Showing Contact Phone
                                                </Typography>
                                            </FormLabel>
                                            <HelpIcon
                                                title={tips?.showingContactPhone.title}
                                                ruleHelp={tips?.showingContactPhone.ruleHelp}
                                                generalHelpDesc={tips?.showingContactPhone.generalHelpDesc}
                                            />
                                        </Box>
                                        <Field
                                            as={TextField}
                                            name="showingContactPhone"
                                            variant="outlined"
                                            required
                                            onChange={(e) => {
                                                const phoneNumber = e.target.value;
                                                handleChange(e);
                                                setFieldValue(
                                                    'showingInstructions',
                                                    `Call management office at ${phoneNumber} to schedule an appointment. Walk-ins welcomed.`
                                                );
                                                setFieldValue('listingOverride', `${phoneNumber}`);
                                                setFieldValue(
                                                    'privateRemarks',
                                                    `For all inquiries and to schedule showings, please contact the leasing office at ${phoneNumber}. All tenant leads will be forwarded directly to the property management team for processing. Units are subject to availability and pricing may vary. Please verify all information before submitting an application. Thank you for showing!`
                                                );
                                            }}
                                            onBlur={handleBlur}
                                            error={touched.showingContactPhone && Boolean(errors.showingContactPhone)}
                                            value={values.showingContactPhone}
                                        />
                                        {touched.showingContactPhone && errors.showingContactPhone && (
                                            <FormHelperText>{errors.showingContactPhone}</FormHelperText>
                                        )}
                                    </FormControl>
                                </Box>
                            </Grid>

                            {role === roles.ADMIN && (
                                <Grid item xs={12}>
                                    <Box sx={{ display: 'flex' }}>
                                        <FormControl fullWidth error={touched.showingInstructions && Boolean(errors.showingInstructions)}>
                                            <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                    <Typography variant="subtitle1" fontWeight="bold" component="span" required>
                                                        Showing Instructions
                                                    </Typography>
                                                </FormLabel>
                                                <HelpIcon
                                                    title={tips?.showingInstructions.title}
                                                    ruleHelp={tips?.showingInstructions.ruleHelp}
                                                    generalHelpDesc={tips?.showingInstructions.generalHelpDesc}
                                                />
                                            </Box>
                                            <Field
                                                as={TextField}
                                                name="showingInstructions"
                                                variant="outlined"
                                                multiline
                                                rows={3}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={touched.showingInstructions && Boolean(errors.showingInstructions)}
                                                value={values.showingInstructions}
                                            />
                                            {touched.showingInstructions && errors.showingInstructions && (
                                                <FormHelperText>{errors.showingInstructions}</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Box>
                                </Grid>
                            )}
                        </Grid>
                    </SubCard>
                </Grid>

                <Remarks
                    role={role}
                    errors={errors}
                    handleSubmit={handleSubmit}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    isSubmitting={isSubmitting}
                    values={values}
                    touched={touched}
                    setFieldValue={setFieldValue}
                />

                <Grid item xs={12} sx={{ mt: 2 }}>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            cursor: 'pointer',
                            mb: 2,
                            p: 1,
                            background: 'white'
                        }}
                        onClick={handleToggle}
                    >
                        <Typography
                            sx={{
                                color: '#919191',
                                fontSize: '16px',
                                fontWeight: '700',
                                textTransform: 'capitalize'
                            }}
                        >
                            Optional Information
                        </Typography>
                        <IconButton>{openOptional ? <ExpandLess /> : <ExpandMore />}</IconButton>
                    </Box>

                    <Collapse in={openOptional}>
                        <SubCard sx={{ pt: '20px' }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    {/* <Typography
                                        sx={{
                                            color: '#919191',
                                            fontSize: '16px',
                                            fontStyle: 'normal',
                                            fontWeight: '700',
                                            lineHeight: 'normal',
                                            textTransform: 'capitalize',
                                            mb: 2
                                        }}
                                    >
                                        Virtual Tours Information
                                    </Typography> */}

                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={6}>
                                            <Box sx={{ display: 'flex' }}>
                                                <FormControl
                                                    fullWidth
                                                    error={touched.brandedVirtualTourURL && Boolean(errors.brandedVirtualTourURL)}
                                                >
                                                    <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                        <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                            <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                Branded Virtual Tour URL
                                                            </Typography>
                                                        </FormLabel>
                                                        <HelpIcon
                                                            title={tips?.brandedVirtualTourURL.title}
                                                            ruleHelp={tips?.brandedVirtualTourURL.ruleHelp}
                                                            generalHelpDesc={tips?.brandedVirtualTourURL.generalHelpDesc}
                                                        />
                                                    </Box>
                                                    <Field
                                                        as={TextField}
                                                        fullWidth
                                                        name="brandedVirtualTourURL"
                                                        variant="outlined"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.brandedVirtualTourURL}
                                                    />
                                                    {touched.brandedVirtualTourURL && errors.brandedVirtualTourURL && (
                                                        <FormHelperText>{errors.brandedVirtualTourURL}</FormHelperText>
                                                    )}
                                                </FormControl>
                                            </Box>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Box sx={{ display: 'flex' }}>
                                                <FormControl
                                                    fullWidth
                                                    error={touched.unbrandedVirtualTourURL && Boolean(errors.unbrandedVirtualTourURL)}
                                                >
                                                    <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                        <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                            <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                Unbranded Virtual Tour URL
                                                            </Typography>
                                                        </FormLabel>
                                                        <HelpIcon
                                                            title={tips?.unbrandedVirtualTourURL.title}
                                                            ruleHelp={tips?.unbrandedVirtualTourURL.ruleHelp}
                                                            generalHelpDesc={tips?.unbrandedVirtualTourURL.generalHelpDesc}
                                                        />
                                                    </Box>
                                                    <Field
                                                        as={TextField}
                                                        fullWidth
                                                        name="unbrandedVirtualTourURL"
                                                        variant="outlined"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.unbrandedVirtualTourURL}
                                                    />
                                                    {touched.unbrandedVirtualTourURL && errors.unbrandedVirtualTourURL && (
                                                        <FormHelperText>{errors.unbrandedVirtualTourURL}</FormHelperText>
                                                    )}
                                                </FormControl>
                                            </Box>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Box sx={{ display: 'flex' }}>
                                                <FormControl
                                                    fullWidth
                                                    error={touched.brandedVideoTourURL && Boolean(errors.brandedVideoTourURL)}
                                                >
                                                    <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                        <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                            <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                Branded Video Tour URL
                                                            </Typography>
                                                        </FormLabel>
                                                        <HelpIcon
                                                            title={tips?.brandedVideoTourURL.title}
                                                            ruleHelp={tips?.brandedVideoTourURL.ruleHelp}
                                                            generalHelpDesc={tips?.brandedVideoTourURL.generalHelpDesc}
                                                        />
                                                    </Box>
                                                    <Field
                                                        as={TextField}
                                                        fullWidth
                                                        name="brandedVideoTourURL"
                                                        variant="outlined"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.brandedVideoTourURL}
                                                    />
                                                    {touched.brandedVideoTourURL && errors.brandedVideoTourURL && (
                                                        <FormHelperText>{errors.brandedVideoTourURL}</FormHelperText>
                                                    )}
                                                </FormControl>
                                            </Box>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Box sx={{ display: 'flex' }}>
                                                <FormControl
                                                    fullWidth
                                                    error={touched.unbrandedVideoTourURL && Boolean(errors.unbrandedVideoTourURL)}
                                                >
                                                    <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                        <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                            <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                Unbranded Video Tour URL
                                                            </Typography>
                                                        </FormLabel>
                                                        <HelpIcon
                                                            title={tips?.unbrandedVideoTourURL.title}
                                                            ruleHelp={tips?.unbrandedVideoTourURL.ruleHelp}
                                                            generalHelpDesc={tips?.unbrandedVideoTourURL.generalHelpDesc}
                                                        />
                                                    </Box>
                                                    <Field
                                                        as={TextField}
                                                        fullWidth
                                                        name="unbrandedVideoTourURL"
                                                        variant="outlined"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.unbrandedVideoTourURL}
                                                    />
                                                    {touched.unbrandedVideoTourURL && errors.unbrandedVideoTourURL && (
                                                        <FormHelperText>{errors.unbrandedVideoTourURL}</FormHelperText>
                                                    )}
                                                </FormControl>
                                            </Box>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Box sx={{ display: 'flex' }}>
                                                <FormControl
                                                    fullWidth
                                                    error={touched.listingDetailedURL && Boolean(errors.listingDetailedURL)}
                                                >
                                                    <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                        <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                            <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                Listing Detailed URL
                                                            </Typography>
                                                        </FormLabel>
                                                        <HelpIcon
                                                            title={tips?.listingDetailedURL.title}
                                                            ruleHelp={tips?.listingDetailedURL.ruleHelp}
                                                            generalHelpDesc={tips?.listingDetailedURL.generalHelpDesc}
                                                        />
                                                    </Box>
                                                    <Field
                                                        as={TextField}
                                                        fullWidth
                                                        name="listingDetailedURL"
                                                        variant="outlined"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.listingDetailedURL}
                                                    />
                                                    {touched.listingDetailedURL && errors.listingDetailedURL && (
                                                        <FormHelperText>{errors.listingDetailedURL}</FormHelperText>
                                                    )}
                                                </FormControl>
                                            </Box>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Box sx={{ display: 'flex' }}>
                                                <FormControl fullWidth error={touched.propertyPanorama && Boolean(errors.propertyPanorama)}>
                                                    <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                        <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                            <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                Create Property Panorama Virtual Tour
                                                            </Typography>
                                                        </FormLabel>
                                                        <HelpIcon
                                                            title={tips?.propertyPanorama.title}
                                                            ruleHelp={tips?.propertyPanorama.ruleHelp}
                                                            generalHelpDesc={tips?.propertyPanorama.generalHelpDesc}
                                                        />
                                                    </Box>
                                                    <Field
                                                        as={Select}
                                                        name="propertyPanorama"
                                                        variant="outlined"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.propertyPanorama}
                                                    >
                                                        <MenuItem value="Yes">Yes</MenuItem>
                                                        <MenuItem value="No">No</MenuItem>
                                                    </Field>
                                                    {touched.propertyPanorama && errors.propertyPanorama && (
                                                        <FormHelperText>{errors.propertyPanorama}</FormHelperText>
                                                    )}
                                                </FormControl>
                                            </Box>
                                        </Grid>

                                        {role === roles.ADMIN && (
                                            <Grid item xs={12} sm={6}>
                                                <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                    <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                        <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                            Syndication Remarks
                                                        </Typography>
                                                    </FormLabel>
                                                    <HelpIcon
                                                        title={tips?.SyndicationRemarks.title}
                                                        ruleHelp={tips?.SyndicationRemarks.ruleHelp}
                                                        generalHelpDesc={tips?.SyndicationRemarks.generalHelpDesc}
                                                    />
                                                </Box>
                                                <Box sx={{ display: 'flex', alignItems: 'end' }}>
                                                    <Field
                                                        as={TextField}
                                                        fullWidth
                                                        name="syndicationRemarks"
                                                        variant="outlined"
                                                        multiline
                                                        rows={4}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.syndicationRemarks}
                                                        error={touched.syndicationRemarks && Boolean(errors.syndicationRemarks)}
                                                        helperText={<ErrorMessage name="syndicationRemarks" />}
                                                    />
                                                </Box>
                                            </Grid>
                                        )}

                                        <Grid item xs={12} sm={4}>
                                            <Box sx={{ display: 'flex' }}>
                                                <FormControl
                                                    fullWidth
                                                    error={touched.showingContactName && Boolean(errors.showingContactName)}
                                                >
                                                    <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                        <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                            <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                Showing Contact Name
                                                            </Typography>
                                                        </FormLabel>
                                                        <HelpIcon
                                                            title={tips?.showingContactName.title}
                                                            ruleHelp={tips?.showingContactName.ruleHelp}
                                                            generalHelpDesc={tips?.showingContactName.generalHelpDesc}
                                                        />
                                                    </Box>
                                                    <Field
                                                        as={TextField}
                                                        name="showingContactName"
                                                        variant="outlined"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.showingContactName}
                                                    />
                                                    {touched.showingContactName && errors.showingContactName && (
                                                        <FormHelperText>{errors.showingContactName}</FormHelperText>
                                                    )}
                                                </FormControl>
                                            </Box>
                                        </Grid>

                                        <Grid item xs={12} sm={4}>
                                            <Box sx={{ display: 'flex' }}>
                                                <FormControl
                                                    fullWidth
                                                    error={touched.showingServicePhone && Boolean(errors.showingServicePhone)}
                                                >
                                                    <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                        <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                            <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                Showing Service Phone
                                                            </Typography>
                                                        </FormLabel>
                                                        <HelpIcon
                                                            title={tips?.showingServicePhone.title}
                                                            ruleHelp={tips?.showingServicePhone.ruleHelp}
                                                            generalHelpDesc={tips?.showingServicePhone.generalHelpDesc}
                                                        />
                                                    </Box>
                                                    <Field
                                                        as={TextField}
                                                        name="showingServicePhone"
                                                        variant="outlined"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.showingServicePhone}
                                                    />
                                                    {touched.showingServicePhone && errors.showingServicePhone && (
                                                        <FormHelperText>{errors.showingServicePhone}</FormHelperText>
                                                    )}
                                                </FormControl>
                                            </Box>
                                        </Grid>

                                        <Grid item xs={12} sm={4}>
                                            <Box sx={{ display: 'flex' }}>
                                                <FormControl
                                                    fullWidth
                                                    error={touched.showingContactType && Boolean(errors.showingContactType)}
                                                >
                                                    <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                        <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                            <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                Showing Contact Type
                                                            </Typography>
                                                        </FormLabel>
                                                        <HelpIcon
                                                            title={tips?.showingContactType.title}
                                                            ruleHelp={tips?.showingContactType.ruleHelp}
                                                            generalHelpDesc={tips?.showingContactType.generalHelpDesc}
                                                            generalHelp={tips?.showingContactType.generalHelp}
                                                        />
                                                    </Box>
                                                    <Select
                                                        multiple
                                                        value={values.showingContactType}
                                                        onChange={(event) => {
                                                            setFieldValue('showingContactType', event.target.value);
                                                        }}
                                                        onBlur={handleBlur}
                                                        input={<OutlinedInput />}
                                                        renderValue={(selected) => selected.join(', ')}
                                                    >
                                                        {['Agent', 'Occupant', 'Owner', 'Property Manager'].map((option) => (
                                                            <MenuItem key={option} value={option} sx={{ my: 0.5 }}>
                                                                <Checkbox checked={values.showingContactType.includes(option)} />
                                                                <ListItemText primary={option} />
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                    {touched.showingContactType && errors.showingContactType && (
                                                        <FormHelperText>{errors.showingContactType}</FormHelperText>
                                                    )}
                                                </FormControl>
                                            </Box>
                                        </Grid>

                                        <Grid item xs={12} md={4}>
                                            <Box sx={{ display: 'flex' }}>
                                                <FormControl
                                                    fullWidth
                                                    error={touched.managementCompany && Boolean(errors.managementCompany)}
                                                >
                                                    <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                        <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                            <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                Management Company
                                                            </Typography>
                                                        </FormLabel>
                                                        <HelpIcon
                                                            title={tips?.managementCompany.title}
                                                            ruleHelp={tips?.managementCompany.ruleHelp}
                                                            generalHelpDesc={tips?.managementCompany.generalHelpDesc}
                                                        />
                                                    </Box>
                                                    <Field
                                                        as={TextField}
                                                        name="managementCompany"
                                                        variant="outlined"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.managementCompany}
                                                        disabled={role === 'APARTMENT_MANAGER' && values.managementCompany !== ''}
                                                        multiline
                                                    />
                                                    {touched.managementCompany && errors.managementCompany && (
                                                        <FormHelperText>{errors.managementCompany}</FormHelperText>
                                                    )}
                                                </FormControl>
                                            </Box>
                                        </Grid>

                                        <Grid item xs={12} md={4}>
                                            <Box sx={{ display: 'flex' }}>
                                                <FormControl
                                                    fullWidth
                                                    error={touched.managementCompanyPhone && Boolean(errors.managementCompanyPhone)}
                                                >
                                                    <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                        <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                            <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                Management Company Phone
                                                            </Typography>
                                                        </FormLabel>
                                                        <HelpIcon
                                                            title={tips?.managementCompanyPhone.title}
                                                            ruleHelp={tips?.managementCompanyPhone.ruleHelp}
                                                            generalHelpDesc={tips?.managementCompanyPhone.generalHelpDesc}
                                                        />
                                                    </Box>
                                                    <Field
                                                        as={TextField}
                                                        name="managementCompanyPhone"
                                                        variant="outlined"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.managementCompanyPhone}
                                                        disabled={role === 'APARTMENT_MANAGER' && values.managementCompanyPhone !== ''}
                                                        multiline
                                                    />
                                                    {touched.managementCompanyPhone && errors.managementCompanyPhone && (
                                                        <FormHelperText>{errors.managementCompanyPhone}</FormHelperText>
                                                    )}
                                                </FormControl>
                                            </Box>
                                        </Grid>

                                        <Grid item xs={12} md={4}>
                                            <Box sx={{ display: 'flex' }}>
                                                <FormControl
                                                    fullWidth
                                                    error={touched.managementCompanyRep && Boolean(errors.managementCompanyRep)}
                                                >
                                                    <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                        <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                            <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                Management Company Rep
                                                            </Typography>
                                                        </FormLabel>
                                                        <HelpIcon
                                                            title={tips?.managementCompanyRep.title}
                                                            ruleHelp={tips?.managementCompanyRep.ruleHelp}
                                                            generalHelpDesc={tips?.managementCompanyRep.generalHelpDesc}
                                                        />
                                                    </Box>
                                                    <Field
                                                        as={TextField}
                                                        name="managementCompanyRep"
                                                        variant="outlined"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.managementCompanyRep}
                                                        multiline
                                                    />
                                                    {touched.managementCompanyRep && errors.managementCompanyRep && (
                                                        <FormHelperText>{errors.managementCompanyRep}</FormHelperText>
                                                    )}
                                                </FormControl>
                                            </Box>
                                        </Grid>

                                        <Grid item xs={12} sm={4}>
                                            <Box sx={{ display: 'flex' }}>
                                                <FormControl
                                                    fullWidth
                                                    error={touched.lockboxSerialNumber && Boolean(errors.lockboxSerialNumber)}
                                                >
                                                    <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                        <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                            <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                Lockbox Serial Number
                                                            </Typography>
                                                        </FormLabel>
                                                        <HelpIcon
                                                            title={tips?.lockboxSerialNumber.title}
                                                            ruleHelp={tips?.lockboxSerialNumber.ruleHelp}
                                                            generalHelpDesc={tips?.lockboxSerialNumber.generalHelpDesc}
                                                        />
                                                    </Box>
                                                    <Field
                                                        as={TextField}
                                                        name="lockboxSerialNumber"
                                                        variant="outlined"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.lockboxSerialNumber}
                                                        error={touched.lockboxSerialNumber && Boolean(errors.lockboxSerialNumber)}
                                                    />
                                                    {touched.lockboxSerialNumber && errors.lockboxSerialNumber && (
                                                        <FormHelperText>{errors.lockboxSerialNumber}</FormHelperText>
                                                    )}
                                                </FormControl>
                                            </Box>
                                        </Grid>

                                        <Grid item xs={12} sm={4}>
                                            <Box sx={{ display: 'flex' }}>
                                                <FormControl fullWidth error={touched.accessCode && Boolean(errors.accessCode)}>
                                                    <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                        <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                            <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                Access Code
                                                            </Typography>
                                                        </FormLabel>
                                                        <HelpIcon
                                                            title={tips?.accessCode.title}
                                                            ruleHelp={tips?.accessCode.ruleHelp}
                                                            generalHelpDesc={tips?.accessCode.generalHelpDesc}
                                                        />
                                                    </Box>
                                                    <Field
                                                        as={TextField}
                                                        name="accessCode"
                                                        variant="outlined"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.accessCode}
                                                        error={touched.accessCode && Boolean(errors.accessCode)}
                                                    />
                                                    {touched.accessCode && errors.accessCode && (
                                                        <FormHelperText>{errors.accessCode}</FormHelperText>
                                                    )}
                                                </FormControl>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </SubCard>
                    </Collapse>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default ShowingInformation;
